import { Controller } from "@hotwired/stimulus"
import { Collapse } from "mdb-ui-kit"
import { useIntersection } from "stimulus-use"

// MDB collapse component
// https://mdbootstrap.com/docs/standard/components/collapse/
// When it is initially hidden or when turbo frame inserts it, we need to
// reinitialize. We are using `.update` since hidden components are already
// initialized. So for all data-mdb-collapse-init add this controller. For example:
//
//    <div data-mdb-collapse-init data-controller="mdb-collapse-appear">
export default class extends Controller {
  connect() {
    console.log("mdb-collapse-appear connect")
    useIntersection(this)
  }

  appear(entry) {
    console.log("mdb-collapse-appear appear")
    new Collapse(this.element)
  }
}
